const i18n = {
  header: {
    1: "Ошибка 404 - Страница не найдена",
    0: "Памылка 404 - Старонка не знойдзена",
  },
  message: {
    1: "Пожалуйста, проверьте правильность ссылки. Возможно, данной страницы не существует, страница устарела или была удалена",
    0: "Калі ласка, праверце правільнасць спасылкі. Магчыма, дадзенай старонкі не існуе, старонка састарэла або была выдаленая",
  },
  back: {
    1: "Вернуться на главную страницу",
    0: "Вярнуцца на галоўную старонку",
  },
};

export default i18n;

